export default  {
  bindings: {
    page: '='
  },
  controller: 'pageContentHomeController',
  template: require('../views/pageContent.home.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/components/pageContent.home.component.js